<template>
  <div class="logo-container">
    <div v-if="this.$browserDetect.isChrome || this.$browserDetect.isSafari || this.$browserDetect.isFirefox" class="shimmer" />
    <img src="../../../assets/images/logo.svg">
  </div>
</template>

<script>
import { gsap } from 'gsap/all'

export default {
  mounted () {
    if (this.$browserDetect.isChrome || this.$browserDetect.isSafari || this.$browserDetect.isFirefox) {
      var tl = gsap.timeline({
        repeat: -1,
        repeatDelay: 4
      })
      tl.fromTo('.logo-container .shimmer', {
        x: -300,
        y: -20,
        rotate: -40
      }, {
        x: 450,
        y: 20,
        rotate: -40,
        duration: 3.5
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/styles/variables';
.logo-container {
  overflow: hidden;
  position: relative;
  .shimmer {
    transform-origin: center center;
    position: absolute;
    filter: blur(30px);
    border-radius: 50%;
    height: 100px;
    mix-blend-mode: color-dodge;
    background-color: rgba($gold, 50%);
    width: 200px;
    z-index: 10;
    top: 50%;
    transform: translateY(-50%);
  }
  img {
    background-color: white;
    mix-blend-mode: color-dodge;
  }
}

</style>
